//@flow
import * as React from "react";
import styled from "react-emotion";
import ProcessItem from "../ProcessItem";
import { black } from "../../styles/colors";
import { theme, mqMin } from "../../styles/theme";
import ScrollNotifier from "../ScrollNotifier";
import { toHtml } from "../../utilities/index";
import eye from "./eye.png";
import glasses from "./glasses.png";
import search from "./search.png";
import camera from "./camera.png";
import video from "./video.png";
import pen from "./pen.png";
import cone from "./cone.png";
import screws from "./screws.png";
import shovel from "./shovel.png";
import bar from "./bar.png";
import pie from "./pie.png";
import chart from "./chart.png";

const OverScroll =
  typeof document !== "undefined" ? require("react-over-scroll").default : null;

const ProcessGrid = styled.section`
  position: relative;
  padding-left: ${theme.space1};
  padding-right: ${theme.space1};
  color: ${black};
`;

const Grid = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  max-width: ${theme.maxWidth3};
  margin-left: auto;
  margin-right: auto;
  transform: translateY(${props => `-${props.progress}%`});
  transition: transform 2s cubic-bezier(0.55, 0, 0.1, 1);
`;

export default ({ processItems }) => {
  const titles = ["Discovery", "The Build", "Content", "Measurement"];
  const images = [
    [eye, glasses, search],
    [cone, screws, shovel],
    [pen, video, camera],
    [chart, bar, pie]
  ];
  const ps = titles.map(
    p => processItems.filter(pi => pi.node.data.name === p)[0].node.data
  );
  return (
    <ProcessGrid>
      <div style={{ overflow: "hidden" }}>
        <Grid>
          <ScrollNotifier onEnter="PROCESS_1" />
          <ScrollNotifier offset="70%" onEnter="PROCESS_2" />
          {ps.map((t, k) => {
            return (
              <React.Fragment key={k}>
                <ProcessItem
                  index={k}
                  heading={t.name}
                  text={t.description.html}
                  images={images[k]}
                />
                <ScrollNotifier offset="70%" onEnter={`PROCESS_${k + 2}`} />
              </React.Fragment>
            );
          })}
        </Grid>
      </div>
    </ProcessGrid>
  );
};



// WEBPACK FOOTER //
// ./src/components/ProcessGrid/index.js